import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Backdrop, Box, Typography } from "@mui/material";
import Cookies from "js-cookie";
import styled from "@emotion/styled";

import Logo from "../assets/xyloplan-logo.png";
import { useAuth } from "contexts/AuthContext";
import { Loader } from "components/UiComponents";
import FirebaseAuthUi from "./FirebaseAuthUi";
import UserAgreement from "./UserAgreement";

const LoginWrapper = styled(Box)(
  ({ theme }) => `
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 350px;
    max-width: 90vw;
    min-height: 380px;

    .firebaseui-container {
      border: 1px solid ${theme.palette.divider};
      box-shadow: none;

      button {
        background-color: ${theme.palette.primary.main} !important;
        box-shadow: "none";
        border-radius: 0;
      }
    }
  `
);

const LoginSplash = () => {
  const { currentUser, isAuthLoading } = useAuth();
  const [showAgreement, setShowAgreement] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const agreementAccepted = Cookies.get("xp-terms-accepted");
    setShowAgreement(agreementAccepted !== "true");
  }, []);

  useEffect(() => {
    if (currentUser) {
      setIsLoggedIn(true);
    }
  }, [currentUser]);

  const handleAcceptAgreement = () => {
    Cookies.set("xp-terms-accepted", "true", { expires: 365 });
    setShowAgreement(false);
  };

  useEffect(() => {
    if (currentUser) {
      const redirectTo =
        location.state?.from?.pathname + location.state?.from?.search || "/";
      navigate(redirectTo, { replace: true });
    }
  }, [currentUser, navigate, location]);
  if (showAgreement === null) {
    return null;
  }

  return (
    <Backdrop
      open={!currentUser || (isLoggedIn && showAgreement)}
      sx={(theme) => ({
        zIndex: theme.zIndex.modal,
        position: "absolute",
        background: theme.palette.background.default,
        display: "flex",
        flexDirection: "column",
      })}
    >
      <Box
        sx={{
          position: "absolute",
          width: "100%",
          top: "-24px",
          "@media (min-height: 600px)": { top: "0" },
          "@media (min-height: 700px)": { top: "32px" },
          "@media (min-height: 900px)": { top: "64px" },
          "@media (min-height: 1100px)": { top: "172px" },
          textAlign: "center",
        }}
      >
        <a href="https://www.xyloplan.com/">
          <img
            src={Logo}
            alt="XyloPlan Logo"
            style={{
              width: "272px",
            }}
          />
        </a>
      </Box>

      <LoginWrapper>
        {isLoggedIn && showAgreement ? (
          <UserAgreement onAccept={handleAcceptAgreement} />
        ) : (
          <>
            <Box
              sx={{
                position: "absolute",
                width: "100%",
                opacity: isAuthLoading ? 1 : 0,
                transition: "opacity 0.5s ease-in-out",
              }}
            >
              <Loader />
            </Box>

            <Box
              sx={{
                opacity: isAuthLoading ? 0 : 1,
                transition: "opacity 0.5s ease-in-out",
              }}
            >
              <FirebaseAuthUi />

              <Typography fontSize="17px" textAlign="center" mt={3}>
                To request access to XyloPlan, contact{" "}
                <a href="mailto:support@xyloplan.com">support@xyloplan.com</a>
              </Typography>
            </Box>
          </>
        )}
      </LoginWrapper>
    </Backdrop>
  );
};

export default LoginSplash;
